// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LinkPresentationProps } from "@insite/mobius/Link";
import AddToList from "@rpsc/XDL/Icons/AddToList";
import IconPrint from "@rpsc/XDL/Icons/IconPrint";
import IconSaveOrder from "@rpsc/XDL/Icons/IconSaveOrder";
import IconTrash from "@rpsc/XDL/Icons/IconTrash";
import { createLinkIconStyles, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

interface CartPageStyles {
    cartActions?: {
        saveOrderLink?: LinkPresentationProps;
        addAllToListClickable?: LinkPresentationProps;
        removeAll?: LinkPresentationProps;
        printLink?: LinkPresentationProps;
    };
}
const linkIconStyles: LinkPresentationProps = {
    typographyProps: {
        size: 12,
        css: css`
            text-wrap: nowrap;
        `,
    },
    icon: {
        iconProps: {
            size: 11,
            css: css`
                &,
                & > svg {
                    height: 13px;
                }
            `,
        },
        position: "left",
    },
};

const cartPageStyles: CartPageStyles = {
    cartActions: {
        saveOrderLink: {
            ...createLinkIconStyles(IconSaveOrder, {
                ...linkIconStyles,
            }),
        },
        addAllToListClickable: {
            ...createLinkIconStyles(
                AddToList,
                mergeWithCss(linkIconStyles, {
                    icon: {
                        iconProps: {
                            size: 12,
                            css: css`
                                &,
                                & > svg {
                                    height: 13px;
                                }
                            `,
                        },
                        position: "left",
                    },
                }),
            ),
        },
        removeAll: {
            ...createLinkIconStyles(IconTrash, {
                ...linkIconStyles,
            }),
        },
        printLink: {
            ...createLinkIconStyles(IconPrint, linkIconStyles),
        },
    },
};

export default cartPageStyles;
